import styled from "styled-components";

import UIFooter from "components/UI/Footer";
import UIButtonPrimary from "components/UI/Button/Primary";
import UIButtonSecondary from "components/UI/Button/Secondary";

export const Wrapper = styled(UIFooter)`
  display: flex;
  flex-direction: row-reverse;
  padding: 15px;
  position: absolute;
`;

export const ButtonPrimary = styled(UIButtonPrimary)`
  margin: 0 10px;
  &:first-child {
    margin: 0 0 0 10px;
  }
`;

export const ButtonSecondary = styled(UIButtonSecondary)`
  margin: 0 10px;
  :first-child {
    margin: 0 0 0 10px;
  }
`;
